import { render, staticRenderFns } from "./MeasureMenuMaxScoreTooltip.vue?vue&type=template&id=a534b3fa&"
import script from "./MeasureMenuMaxScoreTooltip.vue?vue&type=script&lang=js&"
export * from "./MeasureMenuMaxScoreTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports